module.exports = __webpack_public_path__ + "img/video2-poster-m.86164b4d.png";